<h3 mat-dialog-title>Entenda o rateio</h3>

<hr>

<mat-dialog-content>

    <form [formGroup]="form"
          class="row align-items-center">
        <mat-form-field class="col-3">
            <mat-label>Valor total</mat-label>
            <input matInput
                   formControlName="total"
                   money>
        </mat-form-field>

        <mat-form-field class="col-3">
            <mat-label>Quantidade de parcelas</mat-label>
            <input matInput
                   formControlName="parcels"
                   integer
                   class="txt-end">
        </mat-form-field>

        <!-- <mat-form-field class="col-4">
            <mat-select formControlName="condition">
                <mat-label>Condição de pagamento</mat-label>
                @for (condition of paymentConditions; track $index) {
                <mat-option [value]="condition">
                    {{ condition.description }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field> -->
        <!-- <button mat-button
                color="primary"
                type="button"
                (click)="ramdomizeFinance()">Gerar</button> -->


        <mat-form-field class="col-4">
            <mat-label>Tipo de arredondamento</mat-label>
            <mat-select formControlName="roundType">
                @for (mode of ROUND_MODES; track $index) {
                <mat-option [value]="mode.type"> {{mode.label}} </mat-option>
                }
            </mat-select>
        </mat-form-field>

    </form>

    
    @if(grossProduct !== form.value.total) {
        <p class="txt-center">{{ form.value.total | number: "1.2-2" }} ÷ {{ form.value.parcels }} = {{ form.value.total / form.value.parcels | number: "1.0-8" }} ➝ {{ defaultValue | number: "1.2-2" }}</p>
        <hr>
        <p class="txt-center">{{ form.value.parcels }} × {{ defaultValue | number: "1.2-2" }} = {{ grossProduct | currency: "BRL" }} </p>
        <p class="txt-center">E {{grossProduct > form.value.total ? 'subtrai' : 'soma' }} {{ difference}}</p>
    } @else {
        <p class="txt-center">Nenhum ajuste necessário</p>
    }


    <table mat-table
           [dataSource]="table">

        <!-- ROUND_DOWN_FIRST -->
        <ng-container matColumnDef="FIRST">
            <th mat-header-cell
                *matHeaderCellDef
                class="txt-end"> Nas {{ difference * 100 }} primeiras </th>
            <td mat-cell
                *matCellDef="let row"
                [ngClass]="['txt-end', row.FIRST !== defaultValue ? 'changed' : '', 'mode-'+form.value.roundType]">
                {{ row.FIRST | currency: "BRL" }}
            </td>
        </ng-container>

        <!-- ROUND_DOWN_FIRST_ONE -->
        <ng-container matColumnDef="FIRST_ONE">
            <th mat-header-cell
                *matHeaderCellDef
                class="txt-end"> Na primeira </th>
            <td mat-cell
                *matCellDef="let row"
                [ngClass]="['txt-end', row.FIRST_ONE !== defaultValue ? 'changed' : '', 'mode-'+form.value.roundType]">
                {{ row.FIRST_ONE | currency: "BRL" }}
            </td>
        </ng-container>

        <!-- ROUND_DOWN_LAST_ONE -->
        <ng-container matColumnDef="LAST_ONE">
            <th mat-header-cell
                *matHeaderCellDef
                class="txt-end"> Na última </th>
            <td mat-cell
                *matCellDef="let row"
                [ngClass]="['txt-end', row.LAST_ONE !== defaultValue ? 'changed' : '', 'mode-'+form.value.roundType]">
                {{ row.LAST_ONE | currency: "BRL" }}
            </td>
        </ng-container>

        <!-- ROUND_DOWN_LAST -->
        <ng-container matColumnDef="LAST">
            <th mat-header-cell
                *matHeaderCellDef
                class="txt-end"> Nas {{ difference * 100 }} últimas </th>
            <td mat-cell
                *matCellDef="let row"
                [ngClass]="['txt-end', row.LAST !== defaultValue ? 'changed' : '', 'mode-'+form.value.roundType]">
                {{ row.LAST | currency: "BRL" }}
            </td>
        </ng-container>


        <tr mat-header-row
            *matHeaderRowDef="columns"></tr>
        <tr mat-row
            *matRowDef="let row; columns: columns;"></tr>
    </table>


</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
    <button mat-button
            color="warn"
            mat-dialog-close>
        <mat-icon>close</mat-icon>
        Fechar
    </button>
</mat-dialog-actions>